import { Component, OnInit, ViewChild } from '@angular/core';
import { Router } from '@angular/router';
import { DxDataGridComponent, DxSelectBoxComponent } from 'devextreme-angular';
import notify from 'devextreme/ui/notify';
import { moduli } from '../../config';
import { KapacitetLinijaService } from './kapacitet-linija.service';

@Component({
  selector: 'app-kapacitet-linija',
  templateUrl: './kapacitet-linija.component.html',
  styleUrls: ['./kapacitet-linija.component.scss'],
  providers: [KapacitetLinijaService],
})
export class KapacitetLinijaComponent implements OnInit {
  @ViewChild('selectBox', { static: false }) selectBox: DxSelectBoxComponent;
  @ViewChild('numberBox', { static: false }) numberBox: DxSelectBoxComponent;
  @ViewChild('dataGrid', { static: false }) dataGrid: DxDataGridComponent;

  idkorisnik: any = localStorage.getItem('idsecuser');
  access_token: any = sessionStorage.getItem('token');
  idfirma: any = localStorage.getItem('firma');

  odabranaLinija: any;
  startEditAction: string = 'click';
  selectTextOnEditStart: boolean = true;
  linijaProizvodi: any;
  sviProizvodi: any;
  odabraniProizvod: any;
  maksimum: any;
  popupVisible = false;
  karticaLinija: any;
  poruka: string;
  notSaved = false;
  popupChanges = false;
  dodajLinijuPopupVisible = false;
  promjeniNazivPopupVisible = false;
  brisanjeLinijePopupVisible = false;
  menuItems: any;
  noviNazivLinije: string;
  odgovorneOsobe = [];
  arrayLinije = [];
  objektLinija: any;
  bezNaziva = false;
  isContextMenuVisible = false;
  cijenaStruje: number;
  cijenaPlina: number;
  cijenaVode: number;
  cijenaOTP: number;
  odabranoSkladiste: number;
  odabranoGotovoSkladiste: number;
  odabranoSkladisteAmbalaze: number;
  odabraniPogon: number;

  // PRAVA KORISNIKA
  pravaKorisnika = JSON.parse(sessionStorage.getItem('pravakorisnika'));
  trenutniPogled: any;
  pravaZaTrenutniPogled: any;
  prikaziStranicu = 0;
  // KRAJ PRAVA KORISNIKA

  popisAktivnih: boolean;
  djelatnici = [];
  djelatniciNaLiniji = [];
  zaSkladisteAmbalaze: boolean = false;

  skladista: any = [];
  skladistaGotovihProizvoda: any = [];
  skladistaAmbalaze: any = [];

  pogoni: any = [];

  dodaniDjelatnici: any = [];

  constructor(
    private kapacitetLinijaService: KapacitetLinijaService,
    private router: Router,
    private service: KapacitetLinijaService
  ) {
    
    if (parseInt(localStorage.getItem('firma')) == 3) {
      this.router.navigate(['/dostavnica-hlad']);
    }
    this.dohvatiDjelatnike();
    this.dohvatiSkladista();

    // PRAVA KORISNIKA
    this.trenutniPogled = moduli().kapacitetLinija;
    for (var i = 0; i < this.pravaKorisnika.length; i++) {
      //console.log(i);
      if (this.pravaKorisnika[i].smo_ime == this.trenutniPogled) {
        this.pravaZaTrenutniPogled = this.pravaKorisnika[i].sgm_prava;
        //console.log(this.pravaZaTrenutniPogled);
        if (this.pravaKorisnika[i].sgm_prava != 0) {
          this.prikaziStranicu = 1;
        } else {
          notify('Nemate prava.', 'error', 3000);
        }
        return;
      } else {
      }
    }
    // KRAJ PRAVA KORISNIKA
  }

  ngOnInit() {
    this.dohvatiSveProizvode();
    this.menuItems = [{ text: 'Uređivanje' }, { text: 'Obriši liniju' }];
    this.dohvatiSveLinije();
    this.dohvatiSvePogone();
  }

  // -------------------- LINIJE CRUD --------------------
  dohvatiSveLinije() {
    this.kapacitetLinijaService.dohvatiSveLinije({}).subscribe((res) => {
      console.log(res);
      this.arrayLinije = [];
      if (res.success == true) {
        for (let linija of res.data) {
          // console.log(linija);
          this.arrayLinije.push({
            id: linija.idlinija,
            naziv: linija.li_naziv,
            odgovorneOsobe: linija.li_odgovornaosoba,
            idSkladista: linija.poslovnica_idposlovnica,
            nazivSkladista: linija.po_naziv,
            idSkladistaGotovo: linija.poslovnica_idposlovnica_gotovo,
            idSkladistaAmbalaza: linija.poslovnica_idposlovnica_ambalaza,
            idPogon: linija.idpogon
          });
        }
        console.log(this.arrayLinije);
      }
    });
  }

  dohvatiSkladista() {
    this.kapacitetLinijaService.dohvatiSkladista({}).subscribe((res) => {
      console.log('SKLADIŠTA: ', res);
      this.skladista = [];
      this.skladistaGotovihProizvoda = [];
      this.skladistaAmbalaze = [];
      if (res.success == true) {
        // this.skladista = res.data;

        //4- skladište gotovih proizvoda, 5- skladište sirovina, 6- skladišta ambalaže
        for (let i = 0; i < res.data.length; i++) {
          if (res.data[i].idvrstaposlovnice === 4) {
            this.skladistaGotovihProizvoda.push(res.data[i]);
          }
          if (res.data[i].idvrstaposlovnice === 5) {
            this.skladista.push(res.data[i]);
          }
          if (res.data[i].idvrstaposlovnice === 6) {
            this.skladistaAmbalaze.push(res.data[i]);
          }
        }
        console.log('SKLADIŠTA:', this.skladista);
        console.log('SKLADIŠTA GOTOVIH PROIZVODA: ', this.skladistaGotovihProizvoda);
        console.log('SKLADIŠTA AMBALAŽE: ', this.skladistaAmbalaze);
      }
    });
  }

  dohvatiSvePogone(){
    this.pogoni = [];
    this.service.pogoni({idkorisnik: this.idkorisnik, idfirma: this.idfirma}).subscribe((res) => {
      //console.log(res);
      if (res.success == true) {
        this.pogoni = res.data
      }else{

      }
    });
  }

  dodajLinijuPopup() {
    this.dodajLinijuPopupVisible = true;
    this.noviNazivLinije = null;
    this.cijenaStruje = null;
    this.cijenaPlina = null;
    this.cijenaVode = null;
    this.cijenaOTP = null;
    this.odgovorneOsobe = null;
    this.odabranoSkladiste = null;
    this.odabranoGotovoSkladiste = null;
    this.odabranoSkladisteAmbalaze = null;
    this.odabraniPogon = null;
  }

  promjenaNazivaLinije(e) {
    console.log(e);
    this.noviNazivLinije = e.value;
    if (this.noviNazivLinije == '') {
      this.bezNaziva = true;
    } else {
      this.bezNaziva = false;
    }
  }

  changeOdgovornaOsoba(e) {
    console.log(e);
    this.odgovorneOsobe = e.value;
    console.log('ODABRANI DJELATNICI: ', this.odgovorneOsobe);
  }

  promjenaOdgovorneOsobe(e) {
    console.log(e);
    this.dodaniDjelatnici = e.value;
    console.log('DODANI DJELATNICI PROMJENA: ', this.dodaniDjelatnici);
  }

  promjenaCijeneStruje(e) {
    console.log(e);
    this.cijenaStruje = e.value;
  }

  promjenaCijenePlina(e) {
    console.log(e);
    this.cijenaPlina = e.value;
  }

  promjenaCijeneVode(e) {
    console.log(e);
    this.cijenaVode = e.value;
  }

  promjenaCijeneOTP(e) {
    console.log(e);
    this.cijenaOTP = e.value;
  }

  odaberiSkladiste(e) {
    console.log(e);
    this.odabranoSkladiste = e.value;
  }

  odaberiGotovoSkladiste(e) {
    console.log(e);
    this.odabranoGotovoSkladiste = e.value;
  }

  odaberiSkladisteAmbalaze(e) {
    console.log(e);
    this.odabranoSkladisteAmbalaze = e.value;
  }

  odabranPogon(e) {
    console.log(e);
    this.odabraniPogon = e.value;
  }

  odaberiProizvod(e) {
    // console.log(e);
    this.odabraniProizvod = e.value;
  }

  odaberiKolicinu(e) {
    // console.log(e);
    this.maksimum = e.value;
  }

  dodajLiniju() {
    console.log(this.noviNazivLinije);
    if (this.noviNazivLinije === undefined) {
      this.bezNaziva = true;
    } else {
      this.bezNaziva = false;
    }
    let podaciZaSlanje = {
      nazivlinije: this.noviNazivLinije,
      cijenastruje: this.cijenaStruje,
      cijenaplina: this.cijenaPlina,
      cijenavode: this.cijenaVode,
      ostalitroskovi: this.cijenaOTP,
      idposlovnica: this.odabranoSkladiste,
      idposlovnicagotovo: this.odabranoGotovoSkladiste,
      idposlovnicaambalaza: this.odabranoSkladisteAmbalaze,
      idpogon: this.odabraniPogon,
      idkorisnik: localStorage.getItem('idsecuser'),
      idfirma: localStorage.getItem('firma'),
      odgovornaOsobaArray: this.odgovorneOsobe
    }
    console.log(podaciZaSlanje);
    this.kapacitetLinijaService.dodajLiniju(podaciZaSlanje).subscribe((res) => {
      console.log(res);
      if (res.success === true) {
        this.dohvatiSveLinije();
        this.dodajLinijuPopupVisible = false;
        notify('Uspješna dodavanje nove linije!', 'success', 3000);
      }else{
        notify(res.message, 'error', 3000);
      }
    });
  }

  podaciLinija(linija) {
    console.log(linija);
    this.isContextMenuVisible = true;
    this.objektLinija = {
      id: linija.id,
      naziv: linija.naziv,
      odgovorneOsobe: linija.odgovorneOsobe,
      idSkladista: linija.idSkladista,
      nazivSkladista: linija.nazivSkladista,
      idSkladistaGotovo: linija.idSkladistaGotovo,
      idSkladistaAmbalaza: linija.idSkladistaAmbalaza,
      idPogon: linija.idPogon
    };
    console.log(this.objektLinija);
  }

  itemClick(e) {
    console.log(e);
    this.isContextMenuVisible = false;

    if (!e.itemIndex) {
      this.promjeniNazivPopupVisible = true;
      this.dohvatiDjelatnikeNaLiniji();
      this.dohvatiSkladista();

      this.kapacitetLinijaService.dohvatiJednuLiniju({ idlinija: this.objektLinija.id }).subscribe((res) => {
        console.log(res);
        this.cijenaStruje = res.data[0].li_cijenaKW;
        this.cijenaPlina = res.data[0].li_cijenaplina;
        this.cijenaVode = res.data[0].li_cijenavode;
        this.cijenaOTP = res.data[0].li_otkKN;
        this.odabranoSkladiste = res.data[0].poslovnica_idposlovnica;
        this.odabranoGotovoSkladiste = res.data[0].poslovnica_idposlovnica_gotovo;
        this.odabranoSkladisteAmbalaze = res.data[0].poslovnica_idposlovnica_ambalaza;
        this.odabraniPogon = res.data[0].idpogon;
      });
    } else {
      this.brisanjeLinijePopupVisible = true;
    }
  }

  urediLiniju() {
    if (this.noviNazivLinije === undefined) {
      this.noviNazivLinije = this.objektLinija.naziv;
    }
    if (this.odgovorneOsobe === undefined) {
      this.odgovorneOsobe = this.objektLinija.odgovorneOsobe;
    }
    console.log(this.objektLinija);
    console.log(this.noviNazivLinije);
    console.log(this.odgovorneOsobe);

    let podaciZaSlanje = {
      idlinija: this.objektLinija.id,
      nazivlinije: this.noviNazivLinije,
      cijenastruje: this.cijenaStruje,
      cijenaplina: this.cijenaPlina,
      cijenavode: this.cijenaVode,
      ostalitroskovi: this.cijenaOTP,
      idposlovnica: this.odabranoSkladiste,
      idposlovnicagotovo: this.odabranoGotovoSkladiste,
      idposlovnicaambalaza: this.odabranoSkladisteAmbalaze,
      idpogon: this.odabraniPogon,
      idkorisnik: localStorage.getItem('idsecuser'),
      idfirma: localStorage.getItem('firma'),
      odgovornaOsobaArray: this.dodaniDjelatnici
    }
    console.log(podaciZaSlanje);
    this.kapacitetLinijaService.urediLiniju(podaciZaSlanje).subscribe((res) => {
      console.log(res);
      if (res.success === true) {
        this.promjeniNazivPopupVisible = false;
        this.dohvatiSveLinije();
        notify('Uspješna promjena podataka!', 'success', 3000);

        this.odgovorneOsobe = [];
      }else{
        notify(res.message, 'error', 3000);
      }
    });
  }

  obrisiLiniju() {
    this.kapacitetLinijaService.obrisiLiniju({ idlinija: this.objektLinija.id }).subscribe((res) => {
      console.log(res);
      if (res.success === true) {
        this.brisanjeLinijePopupVisible = false;
        this.dohvatiSveLinije();
        notify('Linija uspješno obrisana!', 'success', 3000);
      }else{
        notify(res.message, 'error', 3000);
      }
    });
  }

  zatvoriPopup() {
    this.brisanjeLinijePopupVisible = false;
  }

  // -------------------- DATAGRID --------------------

  onRowUpdated(e) {
    // console.log(e);
    let objekt = {
      idkapacitetlinija: e.data.idLinije,
      maxkolicina: e.data.maksimum,
    };
    // console.log(objekt);
    this.kapacitetLinijaService.urediProizvod(objekt).subscribe((res) => {
      // console.log(res);
    });
  }

  obrisiProizvod(e) {
    // console.log(e);
    let objekt = {
      idkapacitetlinija: e.data.idLinije,
      brojlinije: this.odabranaLinija,
    };
    // console.log(objekt);
    this.kapacitetLinijaService.obrisiProizvod(objekt).subscribe((res) => {
      // console.log(res);
    });
  }

  onToolbarPreparing(e) {
    var toolbarItems = e.toolbarOptions.items;
    toolbarItems.unshift({
      location: 'before',
      template: 'naslovTablice',
    });
  }

  // -------------------- POPUP --------------------

  otvoriPopup() {
    this.popupVisible = true;
    this.selectBox.instance.reset();
    this.numberBox.instance.reset();
    this.poruka = '';
  }

  dohvatiSveProizvode() {
    this.kapacitetLinijaService.dohvatiSveProizvode({}).subscribe((res) => {
      console.log(res);
      this.sviProizvodi = [];
      // this.sviProizvodi = res.data;
      for (let data of res.data) {
        this.sviProizvodi.push({
          id: data.ar_id,
          sifra: data.ar_sifra,
          naziv: data.ar_naziv,
          sifraNaziv: data.sifrainaziv,
        });
      }
      // console.log(this.sviProizvodi);
    });
  }

  dodajProizvod() {
    let objekt = {
      idartikl: this.odabraniProizvod,
      maxkolicina: this.maksimum,
      brojlinije: this.odabranaLinija,
    };
    // console.log(objekt);
    this.kapacitetLinijaService.spremiProizvod(objekt).subscribe((res) => {
      // console.log(res);
      if (res.success == true) {
        this.dohvatiLiniju();
        this.poruka = '';
        this.popupVisible = false;
      } else if (res.message == 'Proizvod je već dodan u liniju!') {
        this.poruka = res.message;
      }
    });
  }

  // -------------------- ODABIR LINIJE --------------------

  odabirLinije(e, l) {
    // console.log(e.target);
    // console.log("Odabrana linija: " + l);
    this.odabranaLinija = l;
    this.karticaLinija = e.target;
    var item = document.getElementsByClassName('grid-item');
    for (let i = 0; i < item.length; i++) {
      item[i].classList.remove('active');
    }
    // this.dohvatiLiniju();
    this.notSaved =
      this.dataGrid == undefined ? false : this.dataGrid.instance.hasEditData();
    // console.log(this.notSaved);
    if (this.notSaved) {
      this.popupChanges = true;
    } else {
      this.popupChanges = false;
      this.dohvatiLiniju();
    }
  }

  dohvatiLiniju() {
    this.kapacitetLinijaService.dohvatiLiniju({ brojlinije: this.odabranaLinija }).subscribe((res) => {
      console.log(res);
      this.karticaLinija.classList.add('active');
      this.linijaProizvodi = [];
      for (let data of res.data) {
        // console.log(data);
        this.linijaProizvodi.push({
          sifra: data.ar_sifra,
          naziv: data.ar_naziv,
          maksimum: data.kl_maxkolicina,
          idLinije: data.idkapacitetlinija,
        });
      }
      // console.log(this.linijaProizvodi);
    });
  }

  // POPUP SPREMI/OTKAŽI
  popupSpremi() {
    this.dataGrid.instance.saveEditData();
    this.popupChanges = false;
    this.dohvatiLiniju();
  }
  popupOtkazi() {
    this.dataGrid.instance.cancelEditData();
    this.popupChanges = false;
    this.dohvatiLiniju();
  }

  numberToHRK(number) {
    return new Intl.NumberFormat('hr-HR', {
      style: 'currency',
      currency: 'HRK',
    }).format(number);
  }

  // ========== DJELATNICI ==========
  dohvatiDjelatnike() {
    this.service.dohvatiDjelatnike({}).subscribe((res) => {
      console.log(res);
      this.djelatnici = [];
      if (res.success == true) {
        this.djelatnici = res.data;
        // console.log(this.djelatnici);
      } else {

      }
    });
  }

  // ========== DJELATNICI LINIJA==========
  dohvatiDjelatnikeNaLiniji() {
    this.popisAktivnih = true;
    // this.poruka = 'Učitavanje...';

    let podaciZaSlanje = {
      idkorisnik: localStorage.getItem('idsecuser'),
      idfirma: localStorage.getItem('firma'),
      idlinija: this.objektLinija.id,
    };

    this.service.dohvatiDjelatnikeNaLiniji(podaciZaSlanje).subscribe((res) => {
      console.log('DJELATNICI LINIJA:  ', res);
      this.djelatniciNaLiniji = [];
      this.dodaniDjelatnici = [];

      if (res.success == true) {
        // if (res.data.length == 0) {
        //   this.poruka = 'Nema rezultata!';
        // } else {
        //   this.poruka = 'Učitavanje...';
        // }

        this.djelatniciNaLiniji = res.data;
        console.log('DJELATNICI NA LINIJI: ', this.djelatniciNaLiniji);

        for (let i = 0; i < res.data.length; i++) {
          if (res.data[i].naliniji === 1) {
            this.dodaniDjelatnici.push(res.data[i]);
          }
        }
        console.log('DODANI DJELATNICI: ', this.dodaniDjelatnici);
      }
      // console.log(this.djelatniciNaLiniji);
      else {
        this.poruka = 'Greška konekcije ili baze!';
      }
    });
  }
}
